"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAccess = exports.capitalizeMonthInDate = exports.capitalize = exports.formatTime = exports.getFileName = exports.onReturnMonthName = exports.truncate = exports.splitWords = exports.isSafari = exports.returnAvatarOrLogoImageSrcValue = exports.formatMoney = exports.getVideoId = exports.weeksBeetwenDate = exports.formatDateEn = exports.formatDateWithRelativeDay = exports.formatDate = exports.formatDateHour = exports.closeModal = exports.showModal = exports.countSpecial = exports.countCharacters = exports.countNumber = exports.countLowercase = exports.countUppercase = exports.onShow = exports.onHide = exports.getFile = exports.getImage = exports.getAvatar = exports.isSuperAdmin = exports.isAdmin = exports.useDevise = exports.useLang = exports.useUser = void 0;
exports.getName = getName;
exports.validateNumber = validateNumber;
exports.validatePhone = validatePhone;
exports.validatePassword = validatePassword;
exports.useLocationState = useLocationState;
exports.createMarkup = createMarkup;
exports.readMarkup = readMarkup;
exports.cleannerError = cleannerError;
exports.QueryUrl = QueryUrl;
exports.formatCurrency = formatCurrency;
exports.isOdd = isOdd;
exports.truncateString = truncateString;
exports.fmtMs = fmtMs;
exports.fmtInt = fmtInt;
exports.fmtPct = fmtPct;
exports.chooseInterval = chooseInterval;
exports.formatMinutesAbbrev = formatMinutesAbbrev;
exports.parseAbbrevMinutes = parseAbbrevMinutes;
const google_libphonenumber_1 = require("google-libphonenumber");
// import Avatar from "./images/default.png";
// import Image from "../assets/appImages/category.png";
const http_1 = require("./http");
const jquery_1 = __importDefault(require("jquery"));
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const hook_1 = require("../redux/hook");
// import { Modal } from "bootstrap";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
const useUser = () => {
    const { user } = (0, hook_1.useAppSelector)((s) => s === null || s === void 0 ? void 0 : s.user);
    return user;
};
exports.useUser = useUser;
const useLang = () => {
    const { lang } = (0, hook_1.useAppSelector)((s) => s === null || s === void 0 ? void 0 : s.locale);
    return lang;
};
exports.useLang = useLang;
const useDevise = () => {
    const { devise } = (0, hook_1.useAppSelector)((s) => s === null || s === void 0 ? void 0 : s.locale);
    return devise;
};
exports.useDevise = useDevise;
function getName(user) {
    // console.log(user,"teste")
    let name = user === null || user === void 0 ? void 0 : user.fullname;
    return name;
}
const phoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
function validateNumber(phone, country) {
    if (!phone || !country)
        return true;
    try {
        const number = phoneUtil.parse(phone, country);
        if (phoneUtil.isPossibleNumber(number) &&
            phoneUtil.isValidNumber(number)) {
            return true;
        }
    }
    catch (ex) {
        console.log("error phone", ex);
    }
    return false;
}
function validatePhone(yup, country) {
    return yup
        .string()
        .test("passwords-match", "Numéro téléphone invalide", (val) => validateNumber(val, country))
        .label("Le téléphone")
        .nullable();
}
function validatePassword(Yup) {
    return Yup.string()
        .required("Le nouveau mot de passe est un champs requis.")
        .matches(/[a-z]+/, "Au moins une minuscule.")
        .matches(/[A-Z]+/, "Au moins une majuscule.")
        .matches(/[!@#$%^&*(),;-_+*/.?":{}|<>]+/, "Au moins un caractère spécial")
        .matches(/\d+/, "Au moins un chiffre.")
        .min(8)
        .label("Password");
}
function useLocationState(defaultValue, redirectToWhenNull = null) {
    const state = (0, react_router_dom_1.useLocation)().state;
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        if (!state && redirectToWhenNull) {
            navigate(redirectToWhenNull);
        }
    }, [state]);
    return state || defaultValue;
}
function createMarkup(text, showDots, numberSlice) {
    return {
        __html: `${numberSlice ? text === null || text === void 0 ? void 0 : text.slice(0, numberSlice) : text}${showDots === true ? "..." : ""}`,
    };
}
function readMarkup(text, showDots, numberSlice) {
    let content = text ? text.replace(/<.+?>/g, "") : text;
    return {
        __html: `${numberSlice ? content.slice(0, numberSlice) : content}${showDots === true ? "..." : ""}`,
    };
}
function cleannerError(errors, cleanner, timeOut = 3000) {
    console.log('errors form', errors);
    if (errors) {
        setTimeout(() => Object.entries(errors).map(([key]) => cleanner(key)), timeOut);
    }
}
function QueryUrl(baseUrl, additionalSearchQuery) {
    if (additionalSearchQuery) {
        for (let key of Object.keys(additionalSearchQuery)) {
            let val = additionalSearchQuery[key];
            if (Array.isArray(val)) {
                if (val.length > 0) {
                    const string = val.map((v) => `${key}=${v}`).join("&");
                    if (baseUrl.includes("?")) {
                        baseUrl += `&${string}`;
                    }
                    else {
                        baseUrl += `?${string}`;
                    }
                }
            }
            else if (typeof val === "boolean") {
                if (baseUrl.includes("?")) {
                    baseUrl += `&${key}=${val}`;
                }
                else {
                    baseUrl += `?${key}=${val}`;
                }
            }
            else {
                if (val) {
                    if (baseUrl.includes("?")) {
                        baseUrl += `&${key}=${val}`;
                    }
                    else {
                        baseUrl += `?${key}=${val}`;
                    }
                }
            }
        }
    }
    return baseUrl;
}
// export const isUser = (user: IUser) => {
//     return user?.status === "student";
// };
const isAdmin = (user) => {
    return ((user === null || user === void 0 ? void 0 : user.status) === "admin" ||
        (user === null || user === void 0 ? void 0 : user.status) === "superadmin");
};
exports.isAdmin = isAdmin;
const isSuperAdmin = (user) => {
    return (user === null || user === void 0 ? void 0 : user.status) === "superadmin";
};
exports.isSuperAdmin = isSuperAdmin;
const getAvatar = (avatar) => {
    if (avatar && !(avatar === null || avatar === void 0 ? void 0 : avatar.includes("default.png"))) {
        if (avatar.indexOf("http") === 0)
            return avatar;
        return `${http_1.ApiBaseUrl}/${avatar}`;
    }
    return "/images/appImages/default.png";
};
exports.getAvatar = getAvatar;
const getImage = (image) => {
    if (image && !(image === null || image === void 0 ? void 0 : image.includes("default.png"))) {
        if (image.indexOf("http") === 0)
            return image;
        return `${http_1.ApiBaseUrl}/${image}`;
    }
    return "/images/appImages/NoImage.png";
};
exports.getImage = getImage;
const getFile = (file) => {
    if (file && !(file === null || file === void 0 ? void 0 : file.includes("default.png"))) {
        if (file.indexOf("http") === 0)
            return file;
        return `${http_1.ApiBaseUrl}/${file}`;
    }
    return "";
};
exports.getFile = getFile;
const onHide = (modalId) => {
    var _a;
    // console.log("modalId",modalId)
    (_a = document.getElementById(modalId)) === null || _a === void 0 ? void 0 : _a.classList.remove("show");
    (0, jquery_1.default)(`#${modalId}`).hide();
    // $(`#${modalId}`).click();
    (0, jquery_1.default)("body").removeClass("modal-open");
    (0, jquery_1.default)(".modal-backdrop").remove();
    (0, jquery_1.default)(`body`).css({ overflowY: "scroll" });
};
exports.onHide = onHide;
const onShow = (modalId) => {
    var _a;
    (_a = document.getElementById(modalId)) === null || _a === void 0 ? void 0 : _a.classList.add("show");
    (0, jquery_1.default)(`#${modalId}`).show();
};
exports.onShow = onShow;
const countUppercase = (str) => {
    var _a;
    if (((_a = str.replace(/[^A-Z]/g, "")) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
        return true;
    }
    return false;
};
exports.countUppercase = countUppercase;
const countLowercase = (str) => {
    var _a;
    if (((_a = str.replace(/[^a-z]/g, "")) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
        return true;
    }
    return false;
};
exports.countLowercase = countLowercase;
const countNumber = (str) => {
    var _a;
    if (((_a = str.replace(/[^0-9]/g, "")) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
        return true;
    }
    return false;
};
exports.countNumber = countNumber;
const countCharacters = (str) => {
    if ((str === null || str === void 0 ? void 0 : str.length) >= 8) {
        return true;
    }
    return false;
};
exports.countCharacters = countCharacters;
const countSpecial = (str) => {
    const punct = `/[!@#$%^&*()_+\\-=\\[\\]{};':"\\|,.<>\\/?]+/;`;
    let count = 0;
    for (let i = 0; i < (str === null || str === void 0 ? void 0 : str.length); i++) {
        if (!punct.includes(str[i])) {
            continue;
        }
        count++;
    }
    // return count;
    if (count >= 1) {
        return true;
    }
    return false;
};
exports.countSpecial = countSpecial;
const CURRENCY_FORMATTER = new Intl.NumberFormat("SN", {
    currency: "XOF",
    style: "currency",
});
function formatCurrency(number) {
    return CURRENCY_FORMATTER.format(number);
}
const showModal = (id) => {
    const element = document.getElementById(id);
    //   const myModal = new Modal(element);
    //   myModal.show();
};
exports.showModal = showModal;
const closeModal = (id) => {
    const element = document.getElementById(id);
    //   const myModal = Modal.getInstance(element);
    //   $(".modal-backdrop").remove();
    //   $("body").removeClass("modal-open");
    //   $("body").css("padding-right", "");
    //   $("body").css("overflow", "auto");
    //   myModal?.hide();
};
exports.closeModal = closeModal;
const formatDateHour = (date) => {
    return (0, moment_1.default)(date).format("DD/MM/YYYY à HH:mm");
};
exports.formatDateHour = formatDateHour;
const formatDate = (date) => {
    return (0, moment_1.default)(date).format("DD/MM/YYYY");
};
exports.formatDate = formatDate;
const formatDateWithRelativeDay = (datetime) => {
    const now = (0, moment_1.default)();
    const inputDate = (0, moment_1.default)(datetime);
    if (inputDate.isSame(now, 'day')) {
        return `Aujourd'hui - ${inputDate.format('HH:mm')}`;
    }
    if (inputDate.isSame(now.clone().subtract(1, 'day'), 'day')) {
        return `Hier - ${inputDate.format('HH:mm')}`;
    }
    return inputDate.format('DD/MM/YYYY - HH:mm');
};
exports.formatDateWithRelativeDay = formatDateWithRelativeDay;
const formatDateEn = (date) => {
    return (0, moment_1.default)(date).format("ll");
};
exports.formatDateEn = formatDateEn;
const weeksBeetwenDate = (date) => {
    let now = (0, moment_1.default)();
    return moment_1.default.duration(now.diff(date)).weeks();
};
exports.weeksBeetwenDate = weeksBeetwenDate;
const getVideoId = (video) => {
    if (!video)
        return "";
    const patterns = [
        /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
        /(?:youtube\.com\/.*[?&]v=|youtube\.com\/v\/|youtube\.com\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    ];
    for (const pattern of patterns) {
        const match = video === null || video === void 0 ? void 0 : video.match(pattern);
        if (match && match[1]) {
            return match[1];
        }
    }
    return "";
};
exports.getVideoId = getVideoId;
function isOdd(num) {
    let isPair = false;
    if (num % 2 === 0) {
        isPair = true;
    }
    else {
        isPair = false;
    }
    return isPair;
}
const formatMoney = (num) => {
    // console.log(num)
    var p = parseFloat(num).toFixed(2).split(".");
    return (p[0]
        .split("")
        .reverse()
        .reduce(function (acc, num, i, orig) {
        return num === "-"
            ? acc
            : num + (i && !(i % 3) ? " " : "") + acc;
    }, "") + " FCFA");
};
exports.formatMoney = formatMoney;
const returnAvatarOrLogoImageSrcValue = (image, fullname) => {
    if (image !== null) {
        return image;
    }
    return `https://ui-avatars.com/api/?name=${fullname}`;
};
exports.returnAvatarOrLogoImageSrcValue = returnAvatarOrLogoImageSrcValue;
function truncateString(str, num) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
}
const isSafari = () => {
    if (navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1) {
        return true;
    }
    else {
        return false;
    }
};
exports.isSafari = isSafari;
const splitWords = (text, numWords) => {
    const words = text.split(" ");
    let part1 = "", part2 = "";
    words.forEach((word, idx) => {
        if (idx < numWords) {
            part1 += " " + word;
        }
        else {
            part2 += " " + word;
        }
    });
    return [part1.trim(), part2.trim()];
};
exports.splitWords = splitWords;
const truncate = (str, no_words) => {
    var _a, _b;
    return ((_b = (_a = str === null || str === void 0 ? void 0 : str.split(" ")) === null || _a === void 0 ? void 0 : _a.splice(0, no_words)) === null || _b === void 0 ? void 0 : _b.join(" ")) + " (...)";
};
exports.truncate = truncate;
const onReturnMonthName = (month_number, locale) => {
    const fr_months = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
    ];
    const en_months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    if (month_number === 1) {
        return locale === "fr" ? fr_months[0] : locale === "en" && en_months[0];
    }
    if (month_number === 2) {
        return locale === "fr" ? fr_months[1] : locale === "en" && en_months[1];
    }
    if (month_number === 3) {
        return locale === "fr" ? fr_months[2] : locale === "en" && en_months[2];
    }
    if (month_number === 4) {
        return locale === "fr" ? fr_months[3] : locale === "en" && en_months[3];
    }
    if (month_number === 5) {
        return locale === "fr" ? fr_months[4] : locale === "en" && en_months[4];
    }
    if (month_number === 6) {
        return locale === "fr" ? fr_months[5] : locale === "en" && en_months[5];
    }
    if (month_number === 7) {
        return locale === "fr" ? fr_months[6] : locale === "en" && en_months[6];
    }
    if (month_number === 8) {
        return locale === "fr" ? fr_months[7] : locale === "en" && en_months[7];
    }
    if (month_number === 9) {
        return locale === "fr" ? fr_months[8] : locale === "en" && en_months[8];
    }
    if (month_number === 10) {
        return locale === "fr" ? fr_months[9] : locale === "en" && en_months[9];
    }
    if (month_number === 11) {
        return locale === "fr"
            ? fr_months[10]
            : locale === "en" && en_months[10];
    }
    if (month_number === 12) {
        return locale === "fr"
            ? fr_months[11]
            : locale === "en" && en_months[11];
    }
};
exports.onReturnMonthName = onReturnMonthName;
const getFileName = (uri) => {
    var _a;
    let name = ((_a = uri === null || uri === void 0 ? void 0 : uri.split(".")) === null || _a === void 0 ? void 0 : _a.length) ? uri === null || uri === void 0 ? void 0 : uri.split(".")[0] : uri;
    return (name === null || name === void 0 ? void 0 : name.includes("mediafiles")) ? name === null || name === void 0 ? void 0 : name.split("/mediafiles/")[1] : name;
};
exports.getFileName = getFileName;
const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
};
exports.formatTime = formatTime;
const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
exports.capitalize = capitalize;
const capitalizeMonthInDate = (date) => {
    if (!date)
        return "";
    const formatted = new Intl.DateTimeFormat("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    }).format(date);
    return formatted.replace(/ (\p{L})/u, (match, p1) => " " + p1.toUpperCase());
};
exports.capitalizeMonthInDate = capitalizeMonthInDate;
const hasAccess = (user, field) => {
    // Early return for super admin
    if ((0, exports.isSuperAdmin)(user)) {
        return false; // Super admin always has access
    }
    // Check if field exists and is explicitly set to 1
    return field === 0;
};
exports.hasAccess = hasAccess;
// export function fmtMs(ms?: number | null): string {
//   if (ms == null) return '—'
//   if (ms < 1) return `${(ms * 1000).toFixed(0)} µs`
//   if (ms < 1000) return `${ms.toFixed(0)} ms`
//   return `${(ms / 1000).toFixed(2)} s`
// }
function fmtMs(input) {
    const n = typeof input === 'number' ? input : Number(input);
    if (!Number.isFinite(n))
        return '—';
    if (n < 1)
        return `${Math.round(n * 1000)} µs`;
    if (n < 1000)
        return `${Math.round(n)} ms`;
    return `${(n / 1000).toFixed(2)} s`;
}
function fmtInt(n) {
    if (n == null)
        return '—';
    return new Intl.NumberFormat('fr-FR').format(Math.round(n));
}
function fmtPct(p) {
    if (p == null)
        return '—';
    return new Intl.NumberFormat('fr-FR', { style: 'percent', maximumFractionDigits: 1 }).format(p);
}
function chooseInterval(fromISO, toISO) {
    const from = new Date(fromISO).getTime();
    const to = new Date(toISO).getTime();
    const diffMin = (to - from) / 60000;
    if (diffMin <= 180)
        return 'minute';
    if (diffMin <= 60 * 24 * 14)
        return 'hour';
    return 'day';
}
// 1) Formater des minutes en "K mn", "M mn", "B mn", etc.
function formatMinutesAbbrev(minutes, decimals = 2) {
    const abs = Math.abs(minutes);
    if (abs < 1000)
        return `${minutes.toFixed(decimals)} mn`;
    const units = [
        { value: 1000, symbol: "K" },
        { value: 1000000, symbol: "M" },
        { value: 1000000000, symbol: "B" },
        { value: 1000000000000, symbol: "T" },
    ];
    // Trouver la plus grande unité applicable
    let unit = units[0];
    for (let i = units.length - 1; i >= 0; i--) {
        if (abs >= units[i].value) {
            unit = units[i];
            break;
        }
    }
    const scaled = minutes / unit.value;
    return `${scaled.toFixed(decimals)}${unit.symbol} mn`;
}
// 2) Parser "2K mn" / "2M mn" -> minutes (nombre)
function parseAbbrevMinutes(text) {
    if (typeof text !== "string")
        return NaN;
    const cleaned = text.trim().toUpperCase().replace(/\s*MN\s*$/, "");
    const match = cleaned.match(/^(-?\d+(\.\d+)?)([KMBT])?$/);
    if (!match)
        return NaN;
    const num = parseFloat(match[1]);
    const unit = match[3] || "";
    const multipliers = {
        "": 1,
        K: 1000,
        M: 1000000,
        B: 1000000000,
        T: 1000000000000,
    };
    return num * multipliers[unit];
}
